var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLensIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5055 13.0171L16.6257 17.125M14.2507 8.8125C14.2507 12.0917 11.5924 14.75 8.31323 14.75C5.03404 14.75 2.37573 12.0917 2.37573 8.8125C2.37573 5.53331 5.03404 2.875 8.31323 2.875C11.5924 2.875 14.2507 5.53331 14.2507 8.8125Z",
    stroke: "#20A6D2",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensIcon);
export default __webpack_public_path__ + "static/media/LensIcon.b581dd49bc9563f37a8a674f6b1d8c9d.svg";
export { ForwardRef as ReactComponent };